import { IAggregatPeriod } from "./aggregatperiod";

export class TaktCalculator {
// eslint-disable-next-line sonarjs/public-static-readonly
    static calculate = (period: IAggregatPeriod,
        sumManad: (period: IAggregatPeriod) => number,
        sumTransporterat: (period: IAggregatPeriod) => number,
        passeradeArbetsdagar: number,
        antalArbetsdagarInnevarandeManad: number): number =>
        period === null ? 0 : this.calculateInner(sumManad(period), sumTransporterat(period), passeradeArbetsdagar, antalArbetsdagarInnevarandeManad);

    private static calculateInner(sumManad: number, sumTransporterat: number, passeradeArbetsdagar: number, antalArbetsdagarInnevarandeManad: number): number {
        if (sumManad === 0 && sumTransporterat === 0) {
            return 0;
        }

        return TaktCalculator.calculateTaktManad(sumManad, sumTransporterat, passeradeArbetsdagar, antalArbetsdagarInnevarandeManad);
    }

    private static calculateTaktManad(sumManad: number, summaTransporterat: number, passeradeArbetsdagar: number, antalArbetsdagarInnevarandeManad: number): number {
        if (sumManad === 0) {
            return 0;
        }

        return TaktCalculator.roundHalfAwayFromZero(
            ((summaTransporterat / passeradeArbetsdagar) *
                antalArbetsdagarInnevarandeManad) /
            sumManad *
            100);
    }

    private static roundHalfAwayFromZero(value: number) {
        if (value >= 0) {
            return Math.round(value);
        }
        return (value % 0.5 === 0) ? Math.floor(value) : Math.round(value);
    }
}
